import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, ListGroup, ListGroupItem, Row } from 'shards-react'
import { get_payer_configuration, reset_payer_configuration, save_payer_configuration } from '../../../redux/actions/subscriber/payConfiguration';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';
import InputBox from '../../../components/common/InputBox';

const AddEditPayerConfig = ({ payerDetail, get_payer_configuration, save_payer_configuration, reset_payer_configuration }) => {
    const { payerRefNum } = useParams();
    const history = useHistory();
    const [formData, setFormData] = useState({
        payerRefNum: 0,
        name: '',
    });

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value })
    }

    useEffect(() => {
        resetForm();
        if (payerRefNum > 0) {
            get_payer_configuration(payerRefNum);
        }
    }, [])

    useEffect(() => {
        if (payerRefNum && Object.keys(payerRefNum).length !== 0) {
            setFormData({
                payerRefNum: payerDetail.payerRefNum,
                name: payerDetail.name,
            });
        }
        else {
            setFormData({
                payerRefNum: 0,
                name: '',
            });
        }
    }, [payerDetail])

    const onSubmit = async (e) => {
        e.preventDefault();
        if (formData.name !== '') {
            await save_payer_configuration(JSON.stringify(formData));
            if (e.nativeEvent.submitter.name === "SaveAnother") {
                resetForm();
            }
            else {
                resetForm();
                history.goBack();
            }
        }
    }

    function resetForm() {
        setFormData({
            payerRefNum: 0,
            name: '',
        });
        reset_payer_configuration();
    }

    function resetAndBack(){
        resetForm();
        history.goBack();
    }

    return (<>
        <Container fluid className="main-content-container p-4">
            <div className="w-100">
                <Form id="frmPayer" onSubmit={onSubmit}>
                    <Card small className="mb-5 w-100 p-1">
                        <h4 className="m-0 section-title idStyle">Ref# {formData.payerRefNum}</h4>
                        <ListGroup flush>
                            <ListGroupItem className="border-card">
                                <Row form>
                                    <Col lg="6" className="form-group m-0 p-2">
                                        <InputBox id="name" name="name" label="Payer" required={true}
                                            value={formData.name} onChange={(e) => onChange(e)} placeholder="Enter payer"
                                            collg={12} align={'left'} />
                                    </Col>

                                    <Col lg="6" className="form-group p-2 m-0 mt-3 file-manager__filters__search d-flex">
                                        <Button className="mx-2 py-2 my-4 btn btn-accent btn-sm" theme="accent" type="submit" name="SaveAnother">
                                            Save And Add Another
                                        </Button>
                                        <Button className="mx-2 py-2 my-4 btn btn-accent btn-sm" theme="accent" type="submit" name="Save">
                                            Save And Return
                                        </Button>
                                        <Button className="mx-2 py-2 my-4 btn btn-accent btn-sm" theme="accent" type="button" onClick={() => { resetAndBack();}}>
                                            Cancel
                                        </Button>
                                    </Col>

                                </Row>
                            </ListGroupItem>
                        </ListGroup>
                    </Card>
                </Form>
            </div>
        </Container>
    </>)
}

const mapStateToProps = (state) => ({
    payerDetail: state.payConfiguration.payerDetail,
});

export default connect(mapStateToProps, { get_payer_configuration, save_payer_configuration, reset_payer_configuration})
    (AddEditPayerConfig)
